import React from 'react';

import GroupIcon from '@mui/icons-material/Group';

import RelatedListCard from '../RelatedListCard';
import RelatedTileGrid from '../RelatedTileGrid';
import { accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';
import { useAccountRelatedPreview } from '../useAccountRelatedRows';

import AccountRelatedContactTile from './AccountRelatedContactTile';
import { toAccountRelatedContact } from './toAccountRelatedContact';

interface Props {
  accountId: string;
}

export default function AccountRelatedContactsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const {
    count,
    error,
    isLoading,
    rows: relatedContacts,
  } = useAccountRelatedPreview(accountId, 'related_contacts', toAccountRelatedContact);

  return (
    <RelatedListCard
      count={count}
      error={error}
      icon={<GroupIcon color="action" />}
      isLoading={isLoading}
      title="Related Contacts"
      viewAllTo={accountPath(accountId, offerId, '/related-contacts')}
    >
      <RelatedTileGrid>
        {relatedContacts.map((relatedContact) => (
          <AccountRelatedContactTile key={relatedContact.id} relatedContact={relatedContact} />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
